"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var React = _interopRequireWildcard(_react);

var _tcombForm = require("tcomb-form");

var _tcombForm2 = _interopRequireDefault(_tcombForm);

var _FormSubmitOnEnter = require("./FormSubmitOnEnter");

var _FormSubmitOnEnter2 = _interopRequireDefault(_FormSubmitOnEnter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Form = _tcombForm2.default.form.Form;

// Provides the same function interface as tcomb.Form but adds auto-keybinding on form-enter
// and fixes issues when forms are used within a bootstrap modal as this is not a stateless component
// attention: only focus-problems are reproduceable when running in production mode (e.g. via npm run watch-cms-prod or npm run watch-app

var TCombFormWrapper = function (_React$Component) {
    _inherits(TCombFormWrapper, _React$Component);

    function TCombFormWrapper() {
        _classCallCheck(this, TCombFormWrapper);

        return _possibleConstructorReturn(this, Object.getPrototypeOf(TCombFormWrapper).apply(this, arguments));
    }

    _createClass(TCombFormWrapper, [{
        key: "getForm",
        value: function getForm() {
            return this.refs.form;
        }
        // same interface tcomb helper to get the value directly out of the form.

    }, {
        key: "getValue",
        value: function getValue() {
            return this.refs.form.getValue();
        }
    }, {
        key: "render",
        value: function render() {
            return React.createElement("form", { onSubmit: this.props.onSubmit, autoCorrect: "off", autoCapitalize: "none", formMethod: "post" }, React.createElement(Form, { ref: "form", type: this.props.type, options: this.props.options, value: this.props.value, onChange: this.props.onChange }), this.props.onEnterSubmit && React.createElement(_FormSubmitOnEnter2.default, null), this.props.children);
        }
    }]);

    return TCombFormWrapper;
}(React.Component);

exports.default = TCombFormWrapper;

TCombFormWrapper.defaultProps = {
    onEnterSubmit: false
};
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/TCombFormWrapper.tsx
 ** module id = 85
 ** module chunks = 0
 **/